import React from 'react';

import { Link } from 'react-router-dom';

import ChevronRightIcon from '../../../assets/icons/ChevronRightIcon';
import { MetaText } from '../../../components/UI/Texts';
import styled from '../../../styled';
import { colorsPalette, TINY_MARGIN_PX } from '../../../theme';

const LinkWithArrow = ({ link, title, ...rest }) => {
  return (
    <StyledLink to={link} {...rest}>
      <Title>{title}</Title>
      <StyledIcon color={colorsPalette.violet} />
    </StyledLink>
  );
};

export default LinkWithArrow;

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
`;

const Title = styled(MetaText)`
  color: ${colorsPalette.violet};
  margin-right: ${TINY_MARGIN_PX};
`;

const StyledIcon = styled(ChevronRightIcon)`
  width: 16px;
  height: 16px;
`;
